/* unplugin-vue-components disabled */import script from "./UpdatePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdatePassword.vue?vue&type=script&setup=true&lang=ts"
/* custom blocks */
import block0 from "./UpdatePassword.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__